import { render, staticRenderFns } from "./StoryVote.vue?vue&type=template&id=a621cc3a"
import script from "./StoryVote.vue?vue&type=script&lang=js"
export * from "./StoryVote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports